import React from "react";
import { ThemeProvider } from "@material-ui/core/styles";
import SubmitForm from "../common/Form/SubmitForm";
import DeleteForm from "../common/Form/DeleteForm";
import theme from "../theme";
import Box from "@material-ui/core/Box";
import SubmitButton from "../common/Button/SubmitButton";
import CancelButton from "../common/Button/CancelButton";
import BackButton from "../common/Button/BackButton";
import DeleteButton from "../common/Button/DeleteButton";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import PopUpDialog from "../common/Dialog/PopUpDialog";
import PopUpForm from "../common/Dialog/PopUpForm";

const useStyles = makeStyles(() => ({
  root: {
    padding: "25px"
  },
  divider: {
    height: "30px"
  }
}));

const Gallery = () => {
  const classes = useStyles();

  return (
    <ThemeProvider theme={theme}>
      <Box className={classes.root} bgcolor="background.default">
        <Typography variant="h5" color="textPrimary">
          Submit Component
        </Typography>
        <SubmitButton onClick={() => alert("Submitting...")} />
        <div className={classes.divider} />

        <Typography variant="h5" color="textPrimary">
          Delete Component:
        </Typography>
        <DeleteButton onClick={() => alert("Deleting...")} />
        <div className={classes.divider} />

        <Typography variant="h5" color="textPrimary">
          Cancel Component:
        </Typography>
        <CancelButton onClick={() => alert("Canceling...")} />
        <div className={classes.divider} />

        <Typography variant="h5" color="textPrimary">
          Back Button:
        </Typography>
        <BackButton onClick={() => alert("Going back...")} />
        <div className={classes.divider} />

        <Typography variant="h5" color="textPrimary">
          PopUp Dialog Component:
        </Typography>
        <PopUpDialog
          popupButtonTitle={"Pop Up Dialog"}
          title={"Are you sure you want to do <action>?"}
          description={"If you do <action>, <this will happen>"}
          onSubmit={() => alert("Submitting from popup...")}
        />
        <div className={classes.divider} />
        <Typography variant="h5" color="textPrimary">
          PopUp Form Component:
        </Typography>
        <PopUpForm
          popupButtonTitle={"Form Pop Up"}
          form={
            <SubmitForm
              title="Submit Form Title"
              description="Submit Form Descriptions"
              onCancel={() => alert("Canceling Submit...")}
              onSubmit={() => alert("Submitting...")}
            />
          } 
        />

        <Typography variant="h5" color="textPrimary">
          Card Component:
        </Typography>
        <div className={classes.divider} />

        <Typography variant="h5" color="textPrimary">
          Submit Form Component:
        </Typography>
        <SubmitForm
          title="Submit Form Title"
          description="Submit Form Descriptions"
          onCancel={() => alert("Canceling Submit...")}
          onSubmit={() => alert("Submitting...")}
        />
        <div className={classes.divider} />

        <Typography variant="h5" color="textPrimary">
          Delete Form Component
        </Typography>
        <DeleteForm
          title="Delete Form Title"
          description="Delete Form Descriptions"
          onCancel={() => alert("Canceling Delete...")}
          onSubmit={() => alert("Deleting...")}
        />
        <div className={classes.divider} />
      </Box>
    </ThemeProvider>
  );
}

export default Gallery;